export default __webpack_public_path__ + "static/media/mysql.3dc77611.png";